// @flow
import type { DevicePanelInfoProps, FormProps } from './types';

import { DeviceInfoPanelList } from './styles';
import EditDeviceName from './edit-device-name';
import * as React from 'react';

type Props = FormProps & DevicePanelInfoProps;

const DefaultInfoPanelList = (props: Props) => (
    <DeviceInfoPanelList>
        <EditDeviceName {...props} />
    </DeviceInfoPanelList>
);

export default DefaultInfoPanelList;



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/panel-list/default.js